import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import AntTable from "../../../components/AntTable/AntTable";
import HeaderTableSuperAdmin from "../../../components/admin/common/HeaderTableSuperAdmin";

import { useMutation, useQuery } from "@tanstack/react-query";
import { Modal, message } from "antd";
import { AiOutlineEdit } from "react-icons/ai";
import AppointmentDetailsModalWrapper from "../../../components/calendar/components/AppointmentDetails/AppointmentDetailsModalWrapper";
import useBreadcrumb from "../../../hooks/useBreadcrumb";
import {
  adminDeleteAppontment,
  getAppointmentsAdmin,
} from "../../../network/admin";
import queryClient from "../../../services/react-query/queryClient";
import { appointmentDetails } from "../../../types/calendar";

type Props = {};
const actionItems = [
  {
    color: "#C43535",
    text: "Delete Appointment",
    title: "Confirm Deletion",
    description: "Are you sure you want to delete this Appointment?",
    status: "delete",
  },
];
const AppointmentsPage = (props: Props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState({
    title: "",
    para: "",
    status: "",
    color: "",
  });
  const [searchHeader, setSearchHeader] = useState();
  const [open, setOpen] = useState(false);
  const [isFilter, setIsFilter] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [selectedAppointment, setSelectedAppointment] =
    useState<appointmentDetails | null>(null);
  const [page, setPage] = useState<number>(1);
  const { data, isLoading } = useQuery(
    ["appointment", page, isFilter, searchHeader],
    () => getAppointmentsAdmin({ page, ...isFilter, search: searchHeader })
  );
  const showModalConfirm = (
    title: string,
    para: string,
    status: string,
    color: string
  ) => {
    setConfirmMessage({ title, para, status, color });
    setIsModalConfirmOpen(true);
  };
  const closeModalConfirm = () => {
    setIsModalConfirmOpen(false);
  };
  const statusColor = (status: string) => {
    switch (status) {
      case "active":
      case "Active":
      case "Completed":
      case "completed":
        return "#479821";
      case "blocked":
      case "Blocked":
        return "#B0B0C0";
      case "pending":
      case "In progress":
      case "started":
        return "#CF953D";
      case "Upcoming":
      case "created":
        return "#00086D";
      case "Cancelled":
      case "canceled":
        return "#C43535";
      default:
        return "#B0B0C0"; // Default color if status doesn't match any case
    }
  };
  const columns: ColumnsType<any> = [
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Appointments No.
        </div>
      ),
      dataIndex: "first_name",
      render: (text: any, record) => (
        <div
          // onClick={() => {
          //   setOpen(true);
          //   setSelectedAppointment(record);
          // }}
          className={`text-color-primary h-10 border-r-0 text-sm font-medium py-3 px-5 `}
        >
          #{record?.id}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">
          Associated salon
        </div>
      ),
      dataIndex: "phone",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={` text-color-primary h-10 border-x-0 text-sm font-medium py-3 px-5`}
          dir="ltr"
        >
          {record?.salon_name}
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">Client name</div>
      ),
      dataIndex: "display_all_booking",

      render: (text: any, record) => (
        <div
          className={`text-[#9999A7] h-10 border-x-0 text-sm font-medium py-3 px-5 `}
        >
          <span className="mx-1 font-semibold text-color-primary">
            {record?.client}
          </span>
        </div>
      ),
    },
    {
      title: (
        <div className="text-[#9999A7] text-sm font-normal">NO. Services </div>
      ),
      dataIndex: "totalSales",

      render: (text: any, record) => (
        <div className={`text-[#9999A7] h-10 py-3 border-x-0 px-5`}>
          <span className="text-sm font-medium text-color-primary">
            {record?.services_count}
          </span>
        </div>
      ),
    },
    {
      title: <div className="text-[#9999A7] text-sm font-normal">Status</div>,
      dataIndex: "created_at",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className={` text-[${statusColor(
            record?.status
          )}] text-sm font-semibold h-10 flex border-l-0 items-center w-full justify-between py-3 px-5`}
        >
          {record?.status}
        </div>
      ),
    },
    {
      title: <div></div>,
      dataIndex: "edit",
      // responsive: ["lg"],
      render: (text: any, record) => (
        <div
          className="w-fit hover:bg-[#EEF0FF] p-2 rounded-full cursor-pointer"
          onClick={() => {
            setEditMode(true);
            setOpen(true);
          }}
        >
          <AiOutlineEdit className="text-[#9999A7]" />
        </div>
      ),
    },
  ];
  const breadcrumb = useBreadcrumb([], 1);

  const { mutate: deleteAppointment, isLoading: isDeleteing } = useMutation(
    adminDeleteAppontment,
    {
      onSuccess: (res: any) => {
        if (res?.status !== 200) {
          message.error(res?.response?.data?.message);
          console.log(res);
        } else {
          console.log(res);
          message.success("Appointment Deleted Successfully");
          queryClient.invalidateQueries(["appointment"]);
          closeModalConfirm();
        }
      },
    }
  );
  return (
    <>
      {breadcrumb}
      <Modal
        width={700}
        open={open}
        footer={null}
        onCancel={() => {
          setOpen(false);
          setSelectedAppointment(null);
        }}
        destroyOnClose={true}
        afterClose={() => {
          setEditMode(false);
        }}
      >
        {selectedAppointment !== null ? (
          <AppointmentDetailsModalWrapper
            setIsModalOpen={setOpen}
            appointment={selectedAppointment}
            editMode={editMode}
            isAdmin={true}
          />
        ) : null}
      </Modal>
      <div className="bg-[#EEF0FF] Appointments mt-20">
        <AntTable
          onRow={(record: any) => {
            return {
              onClick: () => {
                setOpen(true);
                setSelectedAppointment(record);
              },
            };
          }}
          tableColumns={columns}
          tableHeader={
            <div className="flex items-center justify-end">
              <HeaderTableSuperAdmin
                searchHeader={searchHeader}
                setSearchHeader={setSearchHeader}
                selectedRowKeys={selectedRowKeys}
                // labelButton="New Appointment"
                modalId={1}
                setIsFilter={setIsFilter}
                filterType={{ status2: true, bySalon: true, dateAdded: true }}
                actionItems={actionItems}
                confirmMessage={confirmMessage}
                requestDelete={deleteAppointment}
                setConfirmMessage={setConfirmMessage}
                isModalConfirmOpen={isModalConfirmOpen}
                closeModalConfirm={closeModalConfirm}
                showModalConfirm={showModalConfirm}
                placeholderSearch="Search by salon, client.. "
                hasModal={false}
              />
            </div>
          }
          tableData={data?.data}
          isLoading={isLoading}
          expandRowByClick={false}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          // hideArrowExpand
          selectionType={selectedRowKeys}
          setPage={setPage}
          page={page}
          total={data?.meta?.total}
        />
      </div>
    </>
  );
};

export default AppointmentsPage;
